module.exports = __webpack_public_path__ + "assets/img/efd05bd362f452b5ce7f77ca4a3cfd86.png";